import { Grid } from "@mui/material";

import { Label, TextField } from "../../../components";

export default function FormTwo({ formData }) {
  return (
    <Grid item xs={6}>
      <Label title="Company Address" />

      <TextField
        size="small"
        placeholder="Company Address"
        name="companyAddress"
        multiline
        disabled
        value={formData.companyAddress}
      />
    </Grid>
  );
}
